import { createApp } from 'vue'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'

const app = createApp(App)
app.use(VueScrollTo, {
  duration: 800,
  easing: 'ease',
  offset: -80
})
app.mount('#app')
